// src/utils/mapCompany.ts
import { SimilarCompany } from "../types/interfaces";

export interface CompetitorData {
  name: string;
  similarity: number;
  clean_description: string | null;
  logo_url: string | null;
  phone: string | null;
  founded_year: number | null;
  estimated_num_employees: number | null;
  street_address: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  postal_code: string | null;
  website_url: string | null;
  linkedin_url: string | null;
  twitter_url: string | null;
  facebook_url: string | null;
}

export const mapSimilarCompanyToCompetitorData = (
  company: SimilarCompany,
  similarity: number = 0
): CompetitorData => ({
  name: company.name,
  similarity,
  clean_description: company.clean_description || null,
  logo_url: company.logo_url || null,
  phone: company.phone || null,
  founded_year: company.founded_year || null,
  estimated_num_employees: company.estimated_num_employees || null,
  street_address: company.street_address || null,
  city: company.city || null,
  state: company.state || null,
  country: company.country || null,
  postal_code: company.postal_code || null,
  website_url: company.website_url || null,
  linkedin_url: company.linkedin_url || null,
  twitter_url: company.twitter_url || null,
  facebook_url: company.facebook_url || null,
});
